import { Injectable } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Subscription } from 'rxjs';
import { LocationInfo } from './consults.service';
import { Line } from './transportation.service';

@Injectable()
export class ScheduleService {
  constructor(private apiService:ApiService) {}

  getScheduleByLocation(orgLocationId:number, desLocationId:number, callback?: (value:ScheduleByLocation[]) => void, error?: (error) => void, complete?: () => void): Subscription{
    return this.apiService.getInnerTargetApi('schedule/p2p/monitoring/collectinfo/' + orgLocationId + '/' + desLocationId, null, callback, error, complete);
  }

  getScheduleByLine(lineCd, callback?: (value:ScheduleByLine[]) => void, error?: (error) => void, complete?: () => void): Subscription {
    return this.apiService.getInnerTargetApi('schedule/p2p/monitoring/taskinfo/' + lineCd, null, callback, error, complete);
  }

  getSchedules(lineCd, locationId, callback?: (value:Schedules[]) => void, error?: (error) => void, complete?: () => void): Subscription {
    return this.apiService.getInnerTargetApi('schedule/p2p/portmap/' + lineCd, locationId ? {locationId:locationId} : null, callback, error, complete);
  }

  postSchedules(schedulesForPost:SchedulesForPost[], callback?: (value:any) => void, error?: (error) => void, complete?: () => void): Subscription {
    let reqBody = schedulesForPost;
    return this.apiService.postInnerTargetApi('schedule/p2p/portmap', reqBody, callback, error, complete);
  }

  deleteSchedule(lineCd, locationId, callback?: (value:any) => void, error?: (error) => void, complete?: () => void): Subscription {
    return this.apiService.delInnerTargetApi('schedule/p2p/portmap/' + lineCd + '/' + locationId, null, callback, error, complete);
  }
  
}

export class ScheduleByLocation {
  arrLocationId: number;
  cntSchedule: number;
  depLocationId: number;
  regDate: string;
  shprCd: string;
}

export class ScheduleByLine {
  depLocationId: number;
  depLocationName: string;
  arrLocationId: number;
  arrLocationName: string;
  dataYn: number;
  updateDate: string;
}

export class Schedules {
  portMapId: string;
  lineCd: string;
  locationId: number;
  locationCd: string;
  name: string;
  portMapCd: string;
  portMapCd2: string;
  portMapCd3: string;
  portMapCd4: string;
  portMapCd5: string;

  //이하 커스텀
  location:LocationInfo;
  isUpdate:boolean;
  line:Line;

  constructor() {
    this.location = new LocationInfo();
    this.isUpdate = false;
  }
}

export class SchedulesForPost {
  lineCd: string;
  locationId: number;
  portMapCd: string;
  portMapCd2: string;
  portMapCd3: string;
  portMapCd4: string;
  portMapCd5: string;
}


// WEBPACK FOOTER //
// ./src/app/services/schedule.service.ts